import React, { useState } from "react";
import {
  Col,
  Row,
  Button, Form,
  Input, Upload,
  Image,
  Select,
  Card
} from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { CAR } from "../../config/constants/api";
import DashbordSidebar from "../../components/DashboardSidebar";
import facebook from "../../assets/authfb.png";
import twitter from "../../assets/twitter.png";
import google from "../../assets/google.png";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

import swal from "sweetalert";
import { Link } from "react-router-dom";

const normFile = (e) => {
  if (Array.isArray(e)) {
    console.log(e);
    return e;
  }
  return e?.fileList;
};

function CreateAccount() {
  const [form] = Form.useForm();
  const token = useSelector((state) => state.user.userToken);
  const navigate = useNavigate();
  // const [gallery, setGallery] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [passengerCapacityOptions, setPassengerCapacityOptions] = useState([4]);
  const handleUploadChange = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  // const handleChange2 = () => {
  //   swal("", "Congrats! You have been registered successfully", "success");
  // };

  // const handleChange = (value) => {
  //   console.log(`selected ${value}`);
  // };

  // const { Search } = Input;
  // const user = useSelector((state) => state.user.userData);
  // const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = React.useState(false);

  // const onChange = (date, dateString) => {
  //   console.log(date, dateString);
  // };

  const onFinish = (values) => {
    const { brand, name, model, carNumber, serviceType, passengerCapacity } =
      values;
    let data = new FormData();
    data.append("brand", brand);
    data.append("name", name);
    data.append("model", model);
    data.append("carNumber", carNumber);
    data.append("serviceType", serviceType);
    data.append("passengerCapacity", passengerCapacity);
    if (fileList.length > 1) {
      const fileListToAppend = fileList.slice(1).map((file) => {
        return file.originFileObj;
      });
      fileListToAppend.forEach((val) => {
        data.append("gallery", val);
      });
    }
    if (fileList[0]) {
      data.append("image", fileList[0].originFileObj);
    }
    Post(CAR.addCar, data, token, null, "multipart")
      .then((response) => {
        setLoading(false);
        if (response?.status) {
          form.resetFields();
          swal("Success", response?.message, "success");
          navigate("/");
        } else {
          swal("Oops!", response.response.data.message, "error");
        }
      })
      .catch((e) => {
        let message = e?.response?.data?.message || e?.message;
        if (message) {
          swal("Error", message, "error");
        }
        console.log(":::;", e);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // const getBase64 = (img, callback) => {
  //   const reader = new FileReader();
  //   reader.addEventListener("load", () => callback(reader.result));
  //   reader.readAsDataURL(img);
  // };
  // const beforeUpload = (file) => {
  //   const isImage = file.type.startsWith("image/");
  //   if (!isImage) {
  //     message.error("Invalid Uplaod, You can only upload image files!");
  //   }
  //   return isImage;
  // };

  // const multipleChange = (e) => {
  //   setGallery(e.fileList);
  // };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Image
      </div>
    </button>
  );
  const handleVehicleTypeChange = (value) => {
    if (value === "Black") {
      setPassengerCapacityOptions([4, 5, 6]);
    }else if (value === "Suv") {
      setPassengerCapacityOptions([6, 7]);
    } else {
      setPassengerCapacityOptions([4]);
    }
    form.setFieldsValue({ passengerCapacity: null }); // Reset the field
  };
  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div className="about-us-section">
                      <div className="bg-paren">
                        <Row justify="center">
                          <Col xl={24} lg={24} md={22} xs={23}>
                            <Card
                              className="orderDetails"
                              style={{ padding: "10px 0" }}
                            >
                              <Row gutter={30} style={{ marginBottom: "50px" }}>
                                <Col lg={24} md={24} xs={24}>
                                  <div
                                    className="auth-box"
                                    style={{ height: "auto" }}
                                  >
                                    <div className="blur-bg-inner-card-form">
                                      <h2 className="auth-heading">
                                        Vehicle Registration
                                      </h2>
                                      <Form
                                        className="row g-3"
                                        name="basic"
                                        layout="vertical"
                                        initialValues={{
                                          remember: true,
                                        }}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                        form={form}
                                      >
                                        <Row
                                          className="row-res-margin-0"
                                          style={{
                                            width: "100%",
                                            justifyContent: "center",
                                            textAlign: "center",
                                          }}
                                          gutter={[16, 16]}
                                        >
                                          <Col lg={16} md={20} xs={24}>
                                            <p
                                              className="web-p"
                                              style={{
                                                color: "#616161",
                                                paddingTop: "5px",
                                              }}
                                            >
                                              Please register your vehicle. You
                                              will be able to view your
                                              registered vehicle details here.
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row
                                          style={{
                                            width: "100%",
                                            justifyContent: "center",
                                          }}
                                          gutter={[16, 16]}
                                          className="row-res-margin-0"
                                        >
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Vehicle Type"
                                              name="serviceType"
                                            >
                                              <Select
                                                placeholder="Select"
                                                onChange={
                                                  handleVehicleTypeChange
                                                }
                                              >
                                                <Select.Option value="Black">
                                                  Black Luxury
                                                </Select.Option>
                                                <Select.Option value="Ultra">
                                                  Ultra Luxury
                                                </Select.Option>
                                                <Select.Option value="Ultra Beyond">
                                                  Ultra Beyond Luxury
                                                </Select.Option>
                                                <Select.Option value="Suv">
                                                  SUV Luxury
                                                </Select.Option>
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Brand Name"
                                              name="brand"
                                              rules={[
                                                {
                                                  type: "text",
                                                  message:
                                                    "Please enter Brand Name",
                                                },
                                                {
                                                  required: true,
                                                },
                                              ]}
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Brand Name"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Car Name"
                                              name="name"
                                              rules={[
                                                {
                                                  type: "text",
                                                  message:
                                                    "Please enter Car Name",
                                                },
                                                {
                                                  required: true,
                                                },
                                              ]}
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Car Name"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Car Model"
                                              name="model"
                                              rules={[
                                                {
                                                  type: "text",
                                                  message:
                                                    "Please enter Model!",
                                                },
                                                {
                                                  required: true,
                                                },
                                              ]}
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Model"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Car Number"
                                              name="carNumber"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "Please enter Car Number!",
                                                },
                                              ]}
                                            >
                                              <Input
                                                size="large"
                                                placeholder="Enter Car Number of your vehicle"
                                                className="web-input"
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} xs={24}>
                                            <Form.Item
                                              label="Passenger Capacity"
                                              name="passengerCapacity"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "Please select Passenger Capacity!",
                                                },
                                              ]}
                                            >
                                              <Select placeholder="Select">
                                                {passengerCapacityOptions.map(
                                                  (option) => (
                                                    <Select.Option
                                                      key={option}
                                                      value={option}
                                                    >
                                                      {option}
                                                    </Select.Option>
                                                  )
                                                )}
                                              </Select>
                                            </Form.Item>
                                          </Col>

                                          <Col lg={24} md={24} xs={24}>
                                            {/* <Form.Item
                                              valuePropName="fileList"
                                              getValueFromEvent={normFile}
                                            >
                                              <Upload
                                                action="/upload.do"
                                                listType="picture-card"
                                                onChange={multipleChange}
                                              >
                                                <button
                                                  style={{
                                                    border: 0,
                                                    background: "none",
                                                  }}
                                                  type="button"
                                                >
                                                  <PlusOutlined />
                                                  <div
                                                    style={{
                                                      marginTop: 8,
                                                    }}
                                                  >
                                                    Upload Car Images
                                                  </div>
                                                </button>
                                              </Upload>
                                            </Form.Item> */}
                                            <p
                                              style={{
                                                margin: "10px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Upload Images*
                                            </p>
                                            <Form.Item
                                              valuePropName="fileList"
                                              getValueFromEvent={normFile}
                                            >
                                              <Upload
                                                action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                                                listType="picture-card"
                                                fileList={fileList}
                                                onChange={handleUploadChange}
                                              >
                                                {fileList.length >= 8
                                                  ? null
                                                  : uploadButton}
                                              </Upload>
                                            </Form.Item>
                                          </Col>
                                          <div
                                            className=""
                                            style={{
                                              textAlign: "center",
                                              margin: "2px 5px",
                                            }}
                                          >
                                            <Button
                                              type=""
                                              htmlType="submit"
                                              className="btn web-btn px-5"
                                            >
                                              Add Car
                                            </Button>
                                          </div>
                                        </Row>
                                      </Form>
                                      <div className="responsive-auth-social-icon">
                                        <Link>
                                          <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            width={46}
                                            height={46}
                                            src={facebook}
                                            style={{ maxWidth: "46px" }}
                                          />
                                        </Link>
                                        <Link>
                                          <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            width={46}
                                            height={46}
                                            src={twitter}
                                            style={{ maxWidth: "46px" }}
                                          />
                                        </Link>
                                        <Link>
                                          <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            width={46}
                                            height={46}
                                            src={google}
                                            style={{ maxWidth: "46px" }}
                                          />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default CreateAccount;
